enum DataSource {
    ENTITY = 'Entity',
    FLOWABLE = 'Flowable',
}
export default DataSource;
